'use client';

import { memo, useCallback } from 'react';
import { heroConfig } from "@/constant/home";
import { BrandsList } from "../Brands";
import Link from "next/link";
import { useAnalytics } from "@/hooks/usePerformance";
import { TestimonialCarousel } from "@/components/TestimonialCarousel";

function HomeHeroComponent() {
    const { trackEvent } = useAnalytics();

    const handlePrimaryCTAClick = useCallback(() => {
        trackEvent('hero_primary_cta_clicked', {
            cta_text: 'Pricing',
            cta_destination: '/pricing?course=MIM&schools=4',
            cta_position: 'hero',
            cta_type: 'primary',
        });
    }, [trackEvent]);

    const handleSecondaryCTAClick = useCallback(() => {
        trackEvent('hero_secondary_cta_clicked', {
            cta_text: 'Free Profile Review',
            cta_destination: '/profile-evaluation',
            cta_position: 'hero',
            cta_type: 'secondary',
        });
    }, [trackEvent]);

    return (
        <>
            <div className="section_home-header bg-[var(--primary--beige)] dark:bg-[var(--primary--dark)]">
                <div className="padding-global">
                    <div className="container-large">
                        <div className="home_header_component">
                            <div className="home_header_content-left">
                                <div className="margin-bottom margin-xsmall">
                                    <h1 className="text-[var(--primary--burgundy)] dark:text-[var(--primary--pink)]" dangerouslySetInnerHTML={{ __html: heroConfig.headlineForDisplay || heroConfig.headline }}></h1>
                                </div>
                                <div className="margin-bottom margin-small">
                                    <p className="text-size-medium max-width-medium" dangerouslySetInnerHTML={{ __html: heroConfig.subheading }}>
                                        {/* {heroConfig.subheading} */}
                                    </p>
                                </div>
                                <div className="button-row">
                                    <Link
                                        href="/pricing?course=MIM&schools=4"
                                        className="button w-button"
                                        onClick={handlePrimaryCTAClick}
                                    >
                                        Pricing
                                    </Link>
                                    <Link
                                        href="/profile-evaluation"
                                        className="button is-border w-button text-[var(--primary--burgundy)] dark:text-[var(--primary--pink)]"
                                        onClick={handleSecondaryCTAClick}
                                    >
                                        Free Profile Review
                                    </Link>
                                </div>
                                {/* <div className="margin-top margin-large">
                                    <Rating />
                                </div> */}
                            </div>
                            <div className="home_header_content-right">
                                <div className="home_header_backdrop"></div>
                                <TestimonialCarousel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BrandsList brands={heroConfig.logos} brandsTitle={'Where our clients land. And our mentors come from.'} />
        </>
    )
}

// Export memoized component to prevent unnecessary re-renders
export const HomeHero = memo(HomeHeroComponent);
HomeHero.displayName = 'HomeHero';

// Default export for backward compatibility
export default HomeHero;